import Vue from 'vue'
import messages from './messages'

const STORAGE_KEY = 'novalab_locale'
const SUPPORTED_LOCALES = ['zh', 'en']
const DEFAULT_LOCALE = 'zh'

function isSupportedLocale(locale) {
  return SUPPORTED_LOCALES.includes(locale)
}

function getInitialLocale() {
  if (typeof window === 'undefined') return DEFAULT_LOCALE

  const saved = window.localStorage.getItem(STORAGE_KEY)
  return isSupportedLocale(saved) ? saved : DEFAULT_LOCALE
}

export const i18nState = Vue.observable({
  locale: getInitialLocale()
})

function readPath(source, path) {
  return path.split('.').reduce((current, key) => {
    if (current && Object.prototype.hasOwnProperty.call(current, key)) {
      return current[key]
    }
    return undefined
  }, source)
}

function getMessage(path, locale = i18nState.locale) {
  return readPath(messages[locale] || messages[DEFAULT_LOCALE], path)
}

function interpolate(value, params = {}) {
  if (typeof value !== 'string') return value

  return value.replace(/\{(\w+)\}/g, (match, key) => {
    return Object.prototype.hasOwnProperty.call(params, key) ? params[key] : match
  })
}

export function t(path, params) {
  const message = getMessage(path)
  const fallback = getMessage(path, DEFAULT_LOCALE)
  return interpolate(message !== undefined ? message : (fallback !== undefined ? fallback : path), params)
}

export function tm(path) {
  const message = getMessage(path)
  const fallback = getMessage(path, DEFAULT_LOCALE)
  return message !== undefined ? message : fallback
}

export function setLocale(locale) {
  if (!isSupportedLocale(locale)) return

  i18nState.locale = locale

  if (typeof window !== 'undefined') {
    window.localStorage.setItem(STORAGE_KEY, locale)
  }

  if (typeof document !== 'undefined') {
    document.documentElement.lang = locale === 'zh' ? 'zh-CN' : 'en'
  }
}

export default {
  install(VueConstructor) {
    VueConstructor.prototype.$i18n = i18nState
    VueConstructor.prototype.$t = t
    VueConstructor.prototype.$tm = tm
    VueConstructor.prototype.$setLocale = setLocale
    setLocale(i18nState.locale)
  }
}
